module.exports = __webpack_public_path__ + "img/sleeve opening.d6e5c7cf.png";